export const ROUTER_PATHS = {
  /** ログイン画面 */
  login: '/',
  /** 自治体管理者ユーザー管理画面 */
  orgAdminManagement: '/orgAdminManagement',
  /** 団体管理者ユーザー管理画面 */
  orgMemberManagement: '/orgMemberManagement',
  /** アップロード（被災家屋）画面 */
  uploadAeroPic: '/uploadAeroPic',
  /** 固定資産アップロード画面 */
  uploadPropertyTax: '/uploadPropertyTax'
} as const
